import React from 'react';
import PropTypes from 'prop-types';
import IconCollection from '../IconCollection/IconCollection';
import css from './Chevron.module.css';

const Chevron = ({ expanded = true, className = '', style = {}, width = 24, height = 24, ...rest }) => (
    <span
        className={`${css.chevron} ${className}`}
        style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s', ...style }}
        aria-label={expanded ? 'Collapse' : 'Expand'}
        {...rest}
    >
        <IconCollection name="chevron_down" width={width} height={height} />
    </span>
);

Chevron.propTypes = {
    expanded: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.object,
    width: PropTypes.number,
    height: PropTypes.number,
};

export default Chevron;
